<template>
    <div class="w-12 h-12 group relative">
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="group-hover:opacity-0 absolute top-0 transition-opacity duration-150">
            <defs>
                <clipPath id="clippath">
                    <rect class="layer-2-cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="layer-2-cls-4">
                <g>
                    <path class="layer-2-cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="layer-2-cls-3" d="M20.34,27.68c-.26,0-6.39,0-8.01-.44-.51-.14-.97-.41-1.34-.77-.37-.37-.64-.83-.79-1.33-.31-1.69-.45-3.37-.44-5.03,0-1.65.14-3.31.43-4.93.14-.55.4-1.03.78-1.42.37-.39.84-.67,1.36-.81,1.63-.44,7.76-.44,8.02-.44s6.39,0,8,.4c.53.15,1,.43,1.38.82.37.38.64.86.77,1.38v.03c.29,1.64.44,3.31.43,4.98,0,1.63-.14,3.28-.43,4.9-.14.55-.4,1.03-.78,1.42-.38.39-.84.67-1.36.81-1.63.44-7.76.44-8.02.44h0ZM20.34,13.51c-1.74,0-6.51.07-7.75.4-.34.1-.66.28-.91.54-.25.26-.43.58-.52.93-.28,1.53-.41,3.13-.41,4.73-.01,1.61.13,3.22.41,4.8.08.29.27.6.52.85s.56.43.9.52c1.24.33,6.01.4,7.75.4s6.51-.07,7.75-.41c.34-.1.65-.28.91-.54.25-.26.43-.58.52-.93.27-1.52.41-3.11.41-4.69s-.13-3.21-.41-4.78c-.09-.34-.27-.66-.51-.91-.25-.26-.57-.45-.91-.54-1.48-.36-7.68-.37-7.75-.37Z"/>
                    <path class="layer-2-cls-3" d="M18.29,23.61c-.09,0-.17-.02-.25-.07-.15-.09-.25-.25-.25-.43v-6c0-.18.09-.34.25-.43.15-.09.34-.09.5,0l5.27,3c.16.09.25.25.25.43s-.1.35-.25.44l-5.27,3c-.08.04-.16.07-.25.07h0ZM18.79,17.97v4.28l3.76-2.14-3.76-2.14Z"/>
                </g>
            </g>
        </svg>


        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40" class="opacity-0 group-hover:opacity-100 absolute top-0 transition-opacity duration-150">
            <defs>
                <clipPath id="clippath">
                    <rect class="cls-1" x=".35" y=".34" width="39.31" height="39.32"/>
                </clipPath>
            </defs>
            <g class="cls-4">
                <g>
                    <path class="cls-2" d="M20.01.84c10.58,0,19.16,8.58,19.16,19.16s-8.58,19.17-19.16,19.17c-10.58-.01-19.16-8.59-19.16-19.16S9.43.84,20.01.84Z"/>
                    <path class="cls-3" d="M18.79,22.25l3.76-2.14-3.76-2.14v4.28Z"/>
                    <path class="cls-3" d="M30.5,15.14v-.03c-.13-.52-.4-1-.77-1.38-.37-.38-.84-.67-1.38-.81-1.62-.39-7.74-.4-8-.4s-6.39,0-8.02.44c-.52.15-.99.43-1.36.81-.37.38-.64.86-.78,1.41-.29,1.62-.44,3.29-.43,4.93,0,1.66.13,3.34.44,5.03.14.5.42.96.79,1.33.37.37.83.64,1.34.78,1.62.43,7.75.44,8.01.44s6.39,0,8.02-.44c.52-.15.99-.43,1.36-.81s.64-.86.78-1.42c.29-1.62.43-3.27.43-4.9s-.13-3.34-.43-4.98ZM23.81,20.55l-5.27,3c-.08.04-.16.07-.25.07s-.17-.02-.25-.07c-.15-.09-.25-.25-.25-.43v-6c0-.18.09-.34.25-.43.15-.09.34-.09.5,0l5.27,3c.16.09.25.25.25.43s-.1.35-.25.43Z"/>
                </g>
            </g>
        </svg>
    </div>
</template>

<style scoped>
.cls-1, .cls-2 {
    fill: none;
}

.cls-3 {
    fill: #242653;
}

.cls-2 {
    stroke: #242653;
}

.cls-4 {
    clip-path: url(#clippath);
}

.layer-2-cls-1, .layer-2-cls-2 {
    fill: none;
}

.layer-2-cls-3 {
    fill: #242653;
}

.layer-2-cls-2 {
    stroke: #242653;
}

.layer-2-cls-4 {
    clip-path: url(#clippath);
}
</style>
<script setup lang="ts">
</script>